import { i18n } from "@platform/i18n"
import { ErrorMsgMap } from "../../utils/systemError"

export type I18nLangTextMap = Map<string, { [key: string]: string }>

export function LocaleMap(map: any) {
  const _map: I18nLangTextMap = new Map()
  const setLocaleMap = (map: any) => {
    const keys = Object.keys(map)
    for (const k of keys) {
      const last = _map.get(k) || {}
      _map.set(k, { ...last, ...map[k] })
    }
  }

  const getLocaleMap = () => {
    const lang = i18n.getCurrentLang()
    return _map.get(lang)
  }

  const transformLang = (key: string) => {
    const lang = i18n.getCurrentLang()
    const localeMap = _map.get(lang) || {}
    const _language = localeMap[key]
    return _language != undefined ? _language : undefined
  }

  const getText = (
    key: string,
    format?: string | string[] | { [key: string]: string }
  ) => {
    const lang = i18n.getCurrentLang()
    const localeMap = _map.get(lang) || {}
    let _language = localeMap[key]
    const reg = /{(.*?)}/g
    if (format != undefined && reg.test(_language)) {
      if (typeof format !== "object") {
        _language = _language.replace(reg, format)
      } else {
        _language = _language.replace(reg, (item: string, key: number) => {
          return (format as string[])[key] ?? `{${key}}`
        })
      }
    }
    return _language != undefined ? _language : undefined
  }

  setLocaleMap(map || {})

  return {
    setLocaleMap,
    getLocaleMap,
    transformLang,
    getText,
  }
}

export function createLocale(localeMap: { [key: string]: any }) {
  return LocaleMap(localeMap)
}

export function getSystemErrorLang(
  code: string,
  format?: string | string[] | { [key: string]: string }
) {
  const currentLang = i18n.getCurrentLang()

  const langMap =
    ErrorMsgMap[
    ["en-US", "zh-CN"].includes(currentLang) ? currentLang : "en-US"
    ]
  let lang = langMap[code] || ""
  if (!lang?.length) return ""
  const reg = /{(.*?)}/g
  if (format != undefined && reg.test(lang)) {
    if (typeof format !== "object") {
      lang = lang.replace(reg, format)
    } else {
      lang = lang.replace(reg, (item: string, key: number) => {
        return (format as string[])[key] || lang
      })
    }
  }
  return lang
}
